import vueFullcalendar from './fullCalendar'

const fc = vueFullcalendar

module.exports = fc


// WEBPACK FOOTER //
// ./src/components/calendar/index.js